enum AdminEnvironment {
  STAGING = 'staging',
  PRODUCTION = 'production',
}

const AWS_REGION = 'af-south-1';
const AWS_ACCOUNT_ID = '581281163086';

const RESOURCE_PREFIX_BY_ENV: Record<AdminEnvironment, string> = {
  [AdminEnvironment.STAGING]: 'stg-raf',
  [AdminEnvironment.PRODUCTION]: 'prod-raf',
};

export const currentEnvironment =
  process.env.REACT_APP_ENVIRONMENT === AdminEnvironment.STAGING
    ? AdminEnvironment.STAGING
    : AdminEnvironment.PRODUCTION;

const resourcePrefix = RESOURCE_PREFIX_BY_ENV[currentEnvironment];

export const CLOUDWATCH_REGION = AWS_REGION;
export const UPLOADS_BUCKET = `${resourcePrefix}-uploads-${AWS_ACCOUNT_ID}-${AWS_REGION}`;
export const OUTPUTS_BUCKET = `${resourcePrefix}-outputs-${AWS_ACCOUNT_ID}-${AWS_REGION}`;
export const LAMBDA_LOG_GROUP = `/aws/lambda/${resourcePrefix}-api`;

export const getS3UploadsConsoleUrl = (userId: string): string =>
  `https://${AWS_REGION}.console.aws.amazon.com/s3/buckets/${UPLOADS_BUCKET}?prefix=uploads/${userId}/&region=${AWS_REGION}`;

export const getS3OutputConsoleUrl = (outputLocation: string): string =>
  `https://${AWS_REGION}.console.aws.amazon.com/s3/object/${OUTPUTS_BUCKET}?prefix=${outputLocation}&region=${AWS_REGION}`;

const stripExtension = (key: string): string => key.replace(/\.[^.]+$/, '');

export const getS3OcrInputConsoleUrl = (outputLocation: string): string =>
  `https://${AWS_REGION}.console.aws.amazon.com/s3/object/${OUTPUTS_BUCKET}?prefix=${stripExtension(outputLocation)}_ocr-input.txt&region=${AWS_REGION}`;

export const getS3AiResponseConsoleUrl = (outputLocation: string): string =>
  `https://${AWS_REGION}.console.aws.amazon.com/s3/object/${OUTPUTS_BUCKET}?prefix=${stripExtension(outputLocation)}_ai-response.txt&region=${AWS_REGION}`;
